import { useQuery } from '@tanstack/react-query'
import { queryEventsByApplication } from 'supabase/events'

/**
 * Lists the events an application already produced.
 *
 * `enabled` lets the caller skip the query entirely for an unprocessed
 * application, which by definition has produced nothing yet.
 */
export const useQueryEventsByApplication = (
  sourceApplicationId: number,
  enabled = true
) => {
  const { isLoading, isError, data } = useQuery({
    queryKey: ['events', 'byApplication', sourceApplicationId],
    queryFn: () => queryEventsByApplication(sourceApplicationId),
    enabled: !!sourceApplicationId && enabled
  })

  return { events: data ?? [], isLoading, isError }
}
